import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';

import {
  generateCustomIndexFn,
  RouteTabGroupComponent,
  TabGroupConfig,
} from '@features/tab-group/route-tab-group.component';
import { WorkflowPanelComponent } from '@features/workflow-panel/workflow-panel.component';

import { ROUTING_PATH } from '@shared/constants/routingPath';
import { CmcService } from '@shared/services/cmc.service';
import { EventType, PermissionType, WorkflowStep } from '@shared/services/gql.service';
import { LaunchDarklyService } from '@shared/services/launch-darkly.service';
import { AuthService } from '@shared/store/auth/auth.service';
import { EventQuery } from '@shared/store/event/event.query';
import { WorkflowQuery } from '@shared/store/workflow/workflow.query';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, RouteTabGroupComponent, WorkflowPanelComponent],
  selector: 'aux-drivers',
  templateUrl: './drivers.component.html',
})
export class DriversComponent {
  private readonly authService = inject(AuthService);
  private readonly cmcService = inject(CmcService);
  private readonly eventQuery = inject(EventQuery);
  private readonly launchDarklyService = inject(LaunchDarklyService);
  private readonly workflowQuery = inject(WorkflowQuery);

  iCloseMonthsProcessing = this.eventQuery.selectProcessingEvent(EventType.CLOSE_TRIAL_MONTH);
  indexFn = generateCustomIndexFn(
    `${ROUTING_PATH.FORECAST_ROUTING.INDEX}/${ROUTING_PATH.FORECAST_ROUTING.DRIVERS.INDEX}`
  );
  isClosingPanelEnabled = this.launchDarklyService.$select(
    (flags) => flags.closing_checklist_toolbar
  );
  isQuarterCloseEnabled = this.workflowQuery.isWorkflowAvailable;
  tabs: TabGroupConfig[] = [
    {
      label: 'Custom Drivers',
      route: ROUTING_PATH.FORECAST_ROUTING.DRIVERS.CUSTOM_DRIVERS,
      show: toObservable(this.launchDarklyService.$select((flags) => flags.custom_drivers)),
    },
    {
      label: 'Patient Drivers',
      route: ROUTING_PATH.FORECAST_ROUTING.DRIVERS.PATIENT_DRIVER.INDEX,
      show: toObservable(this.cmcService.isTabVisibleForCmc('tab_forecast_drivers')),
    },
    {
      label: 'Site Drivers',
      route: ROUTING_PATH.FORECAST_ROUTING.DRIVERS.SITE_DRIVER.INDEX,
      show: toObservable(this.cmcService.isTabVisibleForCmc('tab_forecast_drivers')),
    },
  ];
  userHasLockDriversPermission = this.authService.$isAuthorized({
    permissions: [PermissionType.PERMISSION_CHECKLIST_PATIENT_SITE_CURVES],
    sysAdminsOnly: false,
  });
  workflowName = WorkflowStep.WF_STEP_MONTH_CLOSE_LOCK_CURVES;
}
